import BaseApi from './BaseApi'

export default class DeviceEventApi extends BaseApi {
    async getDeviceEventsShared (params = {
        name: null,
        description: null,
        dateOfOccurrenceBegin: null,
        dateOfOccurrenceEnd: null,
        expirationDateBegin: null,
        expirationDateEnd: null,
        deviceId: null,
        skip: null,
        take: null,
        hardwareId: null,
        orderBy: null
    }) {
        const request = new URLSearchParams()

        if (params.skip) {
            request.append('Skip', params.skip)
        }

        if (params.take) {
            request.append('Take', params.take)
        }

        if (params.name) {
            request.append('Name', params.name)
        }

        if (params.description) {
            request.append('Description', params.description)
        }

        if (params.dateOfOccurenceBegin) {
            request.append('DateOfOccurrenceBegin', params.dateOfOccurenceBegin)
        }

        if (params.dateOfOccurenceEnd) {
            request.append('DateOfOccurrenceEnd', params.dateOfOccurenceEnd)
        }

        if (params.expirationDateBegin) {
            request.append('ExpirationDateBegin', params.expirationDateBegin)
        }

        if (params.expirationDateEnd) {
            request.append('ExpirationDateEnd', params.expirationDateEnd)
        }

        if (params.deviceId) {
            request.append('DeviceId', params.deviceId)
        }

        if (params.hardwareId) {
            request.append('HardwareId', params.hardwareId)
        }

        if (params.orderBy) {
            request.append('OrderBy', params.orderBy)
        }

        return this.get(`/api/v1.0/deviceEventsShared`, request)
    }
    async getDeviceEventSharedById (eventId) {
        return this.get(`/api/v1.0/deviceEventsShared/${eventId}`)
    }
    async createDeviceEventShare (params = {
        name: null,
        expirationDate: null,
        description: null,
        eventId: null,
        hardwareId: null
    }) {
        return this.post('/api/v1.0/deviceEventsShared', params)
    }
    async updateDeviceEventShare (params = {
        id: null,
        name: null,
        description: null,
        expirationDate: null
    }) {
        return this.put('/api/v1.0/deviceEventsShared', params)
    }
    async getEventMediaByUri (uri) {
        return this.get(`/api/v1.0/deviceEventsShared/eventMedia/${uri}`)
    }
}
